import { render, staticRenderFns } from "./SegmentBlockCard.vue?vue&type=template&id=b4557ac4&"
import script from "./SegmentBlockCard.vue?vue&type=script&lang=js&"
export * from "./SegmentBlockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports